import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import breadcrumbs from '../../breadcrumbs';
import { connect } from 'react-redux';

class Breadcrumbs extends Component {

  constructor(props) {
    super(props);
    this.state = { urlMatch: this.props.match, urlLocation: this.props.location };
    this.breadcrumbLinkList = this.breadcrumbLinkList.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.urlLocation.pathname === nextProps.location.pathname) {
      return
    }

    this.setState({urlMatch: nextProps.match, urlLocation: nextProps.location})
  }

   getPaths = (pathname) => {
    const paths = ['/'];

    if (pathname === '/') return paths;

    pathname.split('/').reduce((prev, curr, index) => {
      const currPath = `${prev}/${curr}`;
      paths.push(currPath);
      return currPath;
    });
    return paths;
  };

  findRouteName = url => breadcrumbs[url];

  breadcrumbLinkList() {
    const paths = this.getPaths(this.state.urlLocation.pathname);
    const links = paths.map((path, i) => this.breadcrumbLink(path, i));

    return (
      links
    )
  }

  breadcrumbLink(path, i) {
    let splittedPath = path.split('/');
    let routeName = this.findRouteName(splittedPath[splittedPath.length-1]);

    if (routeName) {
      return (
        path === this.state.urlLocation.pathname ?
          (
            <BreadcrumbItem active key={i} >{routeName}</BreadcrumbItem>
          ) :
          (
            <BreadcrumbItem key={i}>
              <Link to={path || ''}>
                {routeName}
              </Link>
            </BreadcrumbItem>
          )
      );
    }
    else if(/\/projects\/welds\/logs\/\d+/i.exec(path)) {
      if (path === this.state.urlLocation.pathname) {
        return [
          ...this.props.breadcrumbs.data.map((value, i) => (
            <BreadcrumbItem key={i}>
              <Link to={`/projects/elements/${value.id}`}>{value.name}</Link>
            </BreadcrumbItem>
          )),
          <BreadcrumbItem active key="logs">Logs</BreadcrumbItem>
        ]
      }
      return null;
    }
    else if(/\/projects\/(welds|ndt|elements|details|config|grouping-welds)\/\d*/i.exec(path)) {
      return (
        this.props.breadcrumbs.data.map((value, i) => (
          this.state.urlLocation.pathname.endsWith(`/${value.id}`) ?
            (
              <BreadcrumbItem active key={i} >{value.name}</BreadcrumbItem>
            ) :
            (
              <BreadcrumbItem key={i}>
                <Link to={`/projects/elements/${value.id}`}>
                  {value.name}
                </Link>
              </BreadcrumbItem>
            )
        ))
      )
    }
    else {
      return null;
    }
  }

  render() {
    return (
      <Breadcrumb>
        {this.breadcrumbLinkList()}
      </Breadcrumb>
    );
  }
}

const mapStateToProps = state => ({
  breadcrumbs: state.breadcrumbs
});

export default connect(mapStateToProps)(Breadcrumbs)



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumbs.js